import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { SortContainer, SortLabel, SortSelect } from './SortDropdown.styled';

const SortDropdown = ({ value, onChange }) => {
  const { t } = useTranslation();
  
  const SORT_OPTIONS = [
    { value: '', label: t('sortDefault') },
    { value: 'price_asc', label: t('sortPriceAsc') },
    { value: 'price_desc', label: t('sortPriceDesc') },
    { value: 'name_asc', label: t('sortNameAsc') },
    { value: 'name_desc', label: t('sortNameDesc') },
    { value: 'brand_asc', label: t('sortBrandAsc') },
    { value: 'availability', label: t('sortInStockFirst') },
  ];

  return (
    <SortContainer>
      <SortLabel>
        <i className="mdi mdi-sort" /> {t('sortBy')}
      </SortLabel>
      <SortSelect value={value} onChange={(e) => onChange(e.target.value)}>
        {SORT_OPTIONS.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </SortSelect>
    </SortContainer>
  );
};

SortDropdown.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

export default SortDropdown;


